/** Persist a recipe-rating prompt across navigation (Cook Mode session ended by leaving the page). */

import type { RecipeRatePromptRecipe } from '@/components/recipe/RecipeRatePromptModal'

const STORAGE_KEY = 'culineer:pendingRecipeRatingPrompt'
export const PENDING_RATING_PROMPT_EVENT = 'culineer:pending-recipe-rating-prompt'

export type PendingRecipeRatingPrompt = {
  recipe: RecipeRatePromptRecipe
  queuedAt: number
}

export function queuePendingRecipeRatingPrompt(recipe: RecipeRatePromptRecipe) {
  if (typeof window === 'undefined' || !recipe?.slug) return
  const payload: PendingRecipeRatingPrompt = {
    recipe,
    queuedAt: Date.now(),
  }
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload))
    window.dispatchEvent(new Event(PENDING_RATING_PROMPT_EVENT))
  } catch {
    // ignore quota / private mode
  }
}

export function readPendingRecipeRatingPrompt(): PendingRecipeRatingPrompt | null {
  if (typeof window === 'undefined') return null
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as PendingRecipeRatingPrompt
    if (!parsed?.recipe?.slug) {
      clearPendingRecipeRatingPrompt()
      return null
    }
    // Drop stale queues (> 1 hour)
    if (Date.now() - (parsed.queuedAt || 0) > 60 * 60 * 1000) {
      clearPendingRecipeRatingPrompt()
      return null
    }
    return parsed
  } catch {
    clearPendingRecipeRatingPrompt()
    return null
  }
}

export function clearPendingRecipeRatingPrompt() {
  if (typeof window === 'undefined') return
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    // ignore
  }
}
